var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"add":{icon: 'bx bx-add-to-queue bx-tada', title: 'expense.add', link: 'expense-add'},"title":_vm.$t('expense.text')}}),_c('List',{attrs:{"dataList":_vm.expenseList,"updating":_vm.fetchingStats,"navigate":_vm.pageNavigate,"deletes":[_vm.deleted, null],"formats":[
          {name: 'item'}, 
          {name: 'for_date', type: 'date'},
          {name: 'amount', type: 'currency', sign: '$'} ],"fields":[ 
          ("project_code: " + (_vm.$t('project.text'))),
          ("supplier_name_en: " + (_vm.$t('supplier.text'))),
          ("ref_no: " + (_vm.$t('expense.ref_no'))),
          ("for_date: " + (_vm.$t('expense.date'))),
          ("amount: " + (_vm.$t('expense.amount'))),
          ("item: " + (_vm.$t('expense.item-type'))),
          ("notation: " + (_vm.$t('expense.notation')))
        ],"filter":{
          search: ['income_expenses.ref_no'],
          dropdown:[],
          date: {
            title: 'general.date',
            field: 'sales.for_date'
          }
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }